// extracted by mini-css-extract-plugin
export default {"main_page":"ToyotaCorolla_main_page__ixD+E","car_image":"ToyotaCorolla_car_image__wN61z"};